import PERMISOS from "#constants/perfiles"
import Accordion from "#core/components/accordion/Accordion"
import { UseHasPermission } from "#hooks/useHasPermission"
import { UseJobProfileDetailsContexts } from "#job-profile/contexts/JobProfileDetailsContexts"
import { useColaboradorId } from "app/userSlice"
import { useCallback, useMemo, useState } from "react"
import JobProfileSkills from "../job-profile- skills/JobProfileSkills"
import JobProfileTools from "../job-profile- tools/JobProfileTools"
import JobProfileCompetences from "../job-profile-competences/JobProfileCompetences"
import JobProfileInteraction from "../job-profile-interaction/JobProfileInteraction"
import JobProfileKpis from "../job-profile-kpis/JobProfileKpis"
import JobProfileResponsibilities from "../job-profile-responsibilities/JobProfileResponsibilities"

export default function JobProfileDetailsAccordions({ id }) {
	const { profileId, jobProfile } = UseJobProfileDetailsContexts()
	const [select, setSelect] = useState("")
	const isRh = UseHasPermission(PERMISOS.RH)
	const colaboradorId = useColaboradorId()
	const enabledEdit = useMemo(() => {
		if (!jobProfile) return false
		if (isRh) return true
		if (jobProfile.habilitado === true) return false
		if (!jobProfile.habilitado && jobProfile.created_by === colaboradorId) return true
	}, [isRh, jobProfile, colaboradorId])

	const params = useCallback(
		(name) => ({
			profileId,
			autoFetch: select === name,
			noEdit: !enabledEdit,
		}),
		[enabledEdit, profileId, select],
	)

	const items = [
		{
			id: "responsabilidades",
			label: "RESPONSABILIDADES | TAREAS",
			component: (
				<JobProfileResponsibilities
					key={"responsabilidades"}
					{...params("responsabilidades")}
				/>
			),
		},
		{
			id: "relaciones",
			label: "RELACIONES INTERNOS y/o EXTERNAS",
			component: (
				<JobProfileInteraction
					key={"relaciones"}
					{...params("relaciones")}
					tipo="internas"
				/>
			),
		},
		{
			id: "kpis",
			label: "Indicadores de éxito KPI´s",
			component: <JobProfileKpis {...params("kpis")} key={"kpis"} />,
		},
		{
			id: "competencias",
			label: "Competencias",
			component: (
				<JobProfileCompetences {...params("competencias")} key={"competencias"} />
			),
		},
		{
			id: "skills",
			label: "capacidades profesionales",
			component: <JobProfileSkills key="skills" {...params("skills")} />,
		},
		{
			id: "herramientas",
			label: "Herramientas",
			component: <JobProfileTools key="herramientas" {...params("herramientas")} />,
		},
	]
	return <Accordion items={items} getSelect={setSelect} />
}
